import { fetchCurrentConversationMessages } from "./fetchCurrentConversationMessages"

export const REPLY_TO_CURRENT_CONVERSATION_BEGIN = 'REPLY_TO_CURRENT_CONVERSATION_BEGIN'
export const REPLY_TO_CURRENT_CONVERSATION_SUCCESS = 'REPLY_TO_CURRENT_CONVERSATION_SUCCESS'
export const REPLY_TO_CURRENT_CONVERSATION_FAILED = 'REPLY_TO_CURRENT_CONVERSATION_FAILED'

const replyToCurrentConversationBegin =   (payload) => ({ type: REPLY_TO_CURRENT_CONVERSATION_BEGIN, payload })
const replyToCurrentConversationSuccess = (payload) => ({ type: REPLY_TO_CURRENT_CONVERSATION_SUCCESS, payload })
const replyToCurrentConversationFailed =  (payload) => ({ type: REPLY_TO_CURRENT_CONVERSATION_FAILED, payload })

export const replyToCurrentConversation = (conversation, messageBody) => {
  return (dispatch, getState) => {
    const { organization } = getState()
    dispatch(replyToCurrentConversationBegin())
    return $.ajax({
      url: `/api/staff/v1/conversations/${conversation.id}/reply.json`,
      method: 'POST',
      data: {
        conversation: {
          body: messageBody
        }
      }
    }).then((response)=>{
      dispatch(replyToCurrentConversationSuccess(response))
      dispatch(fetchCurrentConversationMessages(conversation, false))
    })
  }
}